/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import versionService, { VersionService } from '../../services/versionservice';

function VersionChecker() {
  const [showModal, setShowModal] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  // Função para calcular a versão anterior
  const getPreviousVersion = (currentVersion) => {
    const parts = currentVersion.split('.');
    const lastPart = parseInt(parts[parts.length - 1], 10);
    const previousLastPart = Math.max(0, lastPart - 1);
    parts[parts.length - 1] = previousLastPart.toString();
    return parts.join('.');
  };

  // Verificar se o usuário está autenticado
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const token = useSelector((state) => state.auth.token);
  useEffect(() => {
    // Só iniciar verificação se o usuário estiver autenticado
    if (!isLoggedIn || !token) {
      return undefined;
    }

    const handleUpdate = (info) => {
      if (info.hasUpdate) {
        setUpdateInfo(info);
        setShowModal(true);
      }
    };

    // Adicionar listener para atualizações
    versionService.addUpdateListener(handleUpdate);

    // Iniciar verificação automática (a cada 5 minutos)
    versionService.startVersionCheck(5);

    // Cleanup
    return () => {
      versionService.removeUpdateListener(handleUpdate);
      versionService.stopVersionCheck();
    };
  }, [isLoggedIn, token]); // Dependências: só executa quando o estado de login mudar

  const handleUpdateNow = () => {
    setIsUpdating(true);

    // Mostrar mensagem de atualização
    console.log('Iniciando atualização da aplicação...');

    // Parar verificações antes do logout
    versionService.isUpdating = true;
    versionService.stopVersionCheck();

    // Fechar o modal
    setShowModal(false);
    setUpdateInfo(null);

    // Aguardar um momento para mostrar o spinner
    setTimeout(() => {
      VersionService.forceLogoutAndClearCache();
    }, 1000);
  };

  const handleDismiss = () => {
    // Marcar como já visto usando o VersionService
    if (updateInfo && updateInfo.newVersion) {
      versionService.dismissUpdate(updateInfo.newVersion);
    }
    setShowModal(false);
    setUpdateInfo(null);
  };

  if (!showModal || !updateInfo) {
    return null;
  }

  return (
    <Modal
      show={showModal}
      onHide={handleDismiss}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <i className="fas fa-sync-alt me-2" />
          Nova Versão Disponível
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant="info" className="mb-3">
          <Alert.Heading>Atualização Disponível!</Alert.Heading>
          <p className="mb-2">Uma nova versão da aplicação está disponível.</p>
          <hr />
          <div className="d-flex justify-content-between">
            <small>
              <strong>Versão Anterior:</strong>{' '}
              {getPreviousVersion(updateInfo.newVersion)}
            </small>
            <small>
              <strong>Nova Versão:</strong> {updateInfo.newVersion}
            </small>
          </div>
        </Alert>

        <p>
          Para garantir o melhor funcionamento da aplicação, recomendamos
          atualizar agora. A atualização irá:
        </p>

        <ul className="mb-3">
          <li>Carregar a versão mais recente</li>
          <li>Limpar dados em cache</li>
          <li>Fazer logout automático para segurança</li>
        </ul>
        <ul className="mb-3">
          <li>
            <strong>Atualização:</strong>
          </li>
          <li>
            <strong>Melhorias no sistema de Tickets.</strong>
          </li>
          <li>
            Integração com o sistema de <strong> Chatclinic</strong>, onde o
            atendente ao assumir um chat,abrirá uma tela automaticamente com os
            dados daquele contato para abrir um ticket, desde que ele esteja
            cadastrado no sistema OS.OPENNEW. Caso ele tenha mais de uma
            empresa, o agente deverá escolher qual empresa ele deseja abrir o
            ticket na tela de abertura de ticket.
          </li>
          <li>
            Inclusão da Opção de <strong>Protocolo do chat.</strong>
          </li>
          <li>
            Sempre que foi abrir um ticket de origem <strong>WhatsApp</strong>,
            deverá ser informado qual o protocolo do atendimento. Essa
            informação você encontra na tela de atendimentos do Chatclinic,ao
            clicar sobre o nome do contato no chat em aberto, na tela que abrirá
            a direita, em "Informações da Conversa"{' '}
            <strong>
              Só se aplica,quando no mesmo chat o cliente quiser abrir mais de
              um ticket além daquele da automação.
            </strong>
          </li>
          <li>
            Atualizado o menu de relatorio para incluir o filtro de
            <strong> Protocolo do chat</strong>
          </li>
          <li>
            <strong>Correções:</strong>
          </li>
          <li>
            <strong>
              Correções de bugs e melhorias na tela de visualização de tickets e
              na segurança da aplicação.
            </strong>
          </li>
        </ul>

        {isUpdating && (
          <div className="text-center my-3">
            <Spinner
              animation="border"
              size="sm"
              className="me-2"
              role="status"
            />
            <span>Atualizando aplicação...</span>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleDismiss}
          disabled={isUpdating}
        >
          Já fiz
        </Button>
        <Button
          variant="primary"
          onClick={handleUpdateNow}
          disabled={isUpdating}
        >
          {isUpdating ? (
            <>
              <Spinner
                animation="border"
                size="sm"
                className="me-2"
                role="status"
              />
              Atualizando...
            </>
          ) : (
            'Atualizar Agora'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VersionChecker;
